import React from 'react';
import { CreateBetExcelUploadType } from '@/types';
import { createBetExcelUpload } from '@/api/bet/create';
import ExcelUploadBase from './ExcelUploadBase';

export default function ExcelBetUpload() {
  return (
    <ExcelUploadBase<CreateBetExcelUploadType>
      dataType="베팅"
      onUpload={createBetExcelUpload}
      otpTitle="베팅 업로드 인증"
      otpDescription="베팅 업로드를 위해 OTP 인증이 필요합니다."
    />
  );
}
